import { Fragment } from "react";
import Colors from "./App/Assets/Styles/Colors";
import { createTheme, ThemeProvider } from "@mui/material";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import AdminRoute from "./App/Routes/Admin.routes";
import PublicRoutes from "./App/Routes/Public.routes";
import { Layout } from "./App/Layout/Layout";
import useAuth from "./App/hooks/useAuth";
import { ToasterContainer } from "./App/Components/Toaster/Toaster";

const theme = createTheme({
  typography: {
    fontFamily: "Montserrat, sans-serif",
    h1: {
      fontSize: "72px",
    },
    h2: {
      fontSize: "60px",
    },
    h3: {
      fontSize: "48px",
    },
    h4: {
      fontSize: "36px",
    },
    h5: {
      fontSize: "24px",
    },
    h6: {
      fontSize: "18px",
    },
    subtitle1: {
      fontSize: "16px",
    },
    subtitle2: {
      fontSize: "14px",
      fontWeight: 400,
    },
    caption: {
      fontSize: "12px",
    },
  },
  palette: {
    primary: {
      main: Colors.secondary,
    },
    secondary: {
      main: Colors.primary,
    },
  },
});

function App() {
  const { user } = useAuth();
  return (
    <Fragment>
      <ThemeProvider theme={theme}>
        <ToasterContainer />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={user ? <Layout /> : <Navigate to="/login" />}>
              {AdminRoute.map((route, i) => (
                <Route key={i} path={route.path} element={route.component} />
              ))}
            </Route>
            <Route path="/" element={user ? <Navigate to="/dashboard" /> : <Outlet />}>
              {PublicRoutes.map((route, i) => (
                <Route key={i} path={route.path} element={route.component} />
              ))}
            </Route>
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </Fragment>
  );
}

export default App;
